import React, { FC, useState } from 'react';
import { Helmet } from 'react-helmet';

import { useUser } from '../../lib/hooks/user';
import { Header } from './Header';
import { Menus } from './Menus';
import { MenuBar } from './MenuBar';
import { SnackBarProvider } from '../SnackBar';


type Props = {
    defaultCenter?: {
        lat?: number;
        lng?: number;
    };
    previous?: string;
    title?: string;
    disableBackButton?: boolean;
};


export const UserPage: FC<Props> = ({ title, defaultCenter, previous, disableBackButton = false, children }) => {
    const [isOpen, setIsOpen] = useState(false);
    const user = useUser();

    return (
        <SnackBarProvider>
            <main>
                <Helmet title={title || "Salon.jp | マップ"} />

                <div className={['menus-back', isOpen ? 'open' : ''].join(' ')} onClick={() => setIsOpen(!isOpen)}></div>
                <Menus isOpen={isOpen} onClick={() => setIsOpen(!isOpen)} />
                <Header onClick={() => setIsOpen(!isOpen)} />
                <MenuBar defaultCenter={defaultCenter} previous={previous} disableBackButton={disableBackButton} />
                {user && (
                    <div>
                        {children}
                    </div>
                )}
            </main>

            <style jsx>{`
                :global(button) {
                    cursor: pointer;
                }
                main {
                    display: flex;
                    flex-direction: column;
                    min-height: ${window.innerHeight}px;
                }
                .menus-back {
                    position: fixed;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100vh;
                    background: rgba(0, 0, 0, 0);
                    z-index: 9;
                    pointer-events: none;
                    transition: 0.5s;
                }
                .menus-back.open {
                    background: rgba(0, 0, 0, 0.7);
                    pointer-events: auto;
                }
            `}</style>
        </SnackBarProvider>
    );
};
